// FLAGS: authorization
// Bounds where /login may send an already-signed-in scheduler.

/**
 * FLAGS: authorization
 * Loosening this turns /login into an open redirect. Today the value only ever
 * comes from ProtectedRoute's navigation state, never from the URL, so this is
 * defence in depth rather than the only thing standing in the way.
 * Returns the value only when it is a safe, app-relative path — guards
 * against open redirects (e.g. "//evil.com", "https://evil.com").
 */
const getSafeRedirectPath = (value: unknown): string | null => {
  if (typeof value !== "string" || value.length === 0) {
    return null;
  }
  return value.startsWith("/") && !value.startsWith("//") ? value : null;
};

export default getSafeRedirectPath;
